module.exports = __webpack_public_path__ + "static/media/lineVerticalStudent.4510f9ae.svg";